angular.module('dealerware.web.data').factory('DealerwareManagedCompanyCollection',function(Model,Collection){

    var collection = new Collection({
        baseEndpoint: '/companies',
        model: 'ManagedCompanyModel',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            }
        },
        params: {
            sort_by: 'name',
            sort_direction: 'asc'
        }
    });


    jQuery.extend(collection.prototype,{
        getById : function(id) {
            var company = null;
            $.each(this.data, function(idx, value) {
                if (id == value.data.id) {
                    company = value;
                    return false;
                }
            });
            return company;
        }
    });

    return collection;
})
.config(function($provide) {
    $provide.decorator('ManagedCompanyCollection', function($delegate, $injector) {
        return $injector.get('DealerwareManagedCompanyCollection');
    });
});
